'use strict';

wbApp.controller('ActionsCtrl', ['$scope', 'tenantSettingSvc',
function ($scope, tenantSettingSvc) {
    var data = actionList;

    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.actions = data;

    $scope.startDate = moment().toDate();
    $scope.endDate = moment().add('days', $scope.tenantSettings.noOfDaysToShowAction).toDate()

    $scope.setSelectedAction = function (action) {
       // if (action.freeCapacity !== 0) {
            $scope.selectedAction = action;
            window.location = "/Actions/Register/" + action.id + "?returnUrl=Actions";
     //   }
    }

    $scope.tabs = [
        {
            title: $scope.tenantSettings.eventsMenuName
                ? $scope.tenantSettings.eventsMenuName
                : 'TXT_TITLE_ACTIONS',
            template: 'actions/actions-list-tab.html'
        }
    ];

    $scope.tabs.activeTab = 0;
}]);